import React, { useState } from 'react';
import image from '../../assets/images/login-imge.png';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Popup from '../RegisterScreen/Popup';
import { api } from '../../Constant';

const LoginPage = () => {
    const location = useLocation();
    const navigation = useNavigate();

    // Get product details passed via navigate state, fallback to undefined
    const { product_id, size: addsize, quantity } = location.state || {};

    const [formData, setFormData] = useState({
        user_name: '',
        password: '',
    });

    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupTitle, setPopupTitle] = useState('Notification');



    // console.log("User ID:", localStorage.getItem("userId"));
    // console.log("Guest ID:", localStorage.getItem("guest_id"));



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(api + 'login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    product_id, // pass product details here
                    size: addsize,
                    quantity,
                }),
            });

            const data = await response.json();

            if (response.ok && data.success === "true") {
                localStorage.setItem('userId', data.user.id);
                localStorage.setItem('userName', data.user.user_name);
                setPopupTitle('Success');
                setPopupMessage('Login successful!');
                setShowPopup(true);

                setTimeout(() => {
                    navigation('/');
                }, 1000);
            } else {
                setPopupTitle('Error');
                setPopupMessage(data.message || 'Login credentials are invalid');
                setShowPopup(true);
            }
        } catch (error) {
            setPopupTitle('Error');
            setPopupMessage('An error occurred. Please try again.');
            setShowPopup(true);
        }
    };

    const handleGuestLogin = async () => {
        const storedGuestId = localStorage.getItem('guest_id');
        if (storedGuestId) {
            // Returning guest
            localStorage.setItem('userId', storedGuestId);
            localStorage.setItem('userName', 'Guest');
            localStorage.setItem('hasShownPopup', '');
            setPopupTitle('Guest Login');
            setPopupMessage('Welcome back, Guest!');
            setShowPopup(true);

            setTimeout(() => {
                navigation('/');
            }, 1000);
        } else {
            // New guest with product details
            try {
                const response = await fetch(api + 'get_guest_id', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        product_id,
                        size: addsize,
                        quantity
                    })
                });

                const data = await response.json();
                console.log("Guest API Response:", data);

                if (response.ok && (data.success === true || data.success === "true")) {
                    localStorage.setItem('guest_id', data.guest_id.toString());
                    localStorage.setItem('userId', data.guest_id.toString());
                    localStorage.setItem('userName', 'Guest');
                    localStorage.setItem('hasShownPopup', '');
                    setPopupTitle('Guest Login');
                    setPopupMessage(data.message || 'You are logged in as a Guest.');
                    setShowPopup(true);

                    setTimeout(() => {
                        navigation('/');
                    }, 1000);
                } else {
                    setPopupTitle('Error');
                    setPopupMessage(data.message || 'Unable to login as Guest');
                    setShowPopup(true);
                }
            } catch (error) {
                console.error("Guest login error:", error);
                setPopupTitle('Error');
                setPopupMessage('Something went wrong during guest login.');
                setShowPopup(true);
            }
        }
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    return (
        <div className='login-page-bg pt-80 pb-80'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12 login-img'>
                        <div className='img'>
                            <img src={image} alt="Login" />
                        </div>
                        <div className='login-form'>
                            <div className='row'>
                                <div className='col-lg-12 title'>
                                    <h3>Login</h3>
                                </div>
                            </div>
                            <form className='row' onSubmit={handleSubmit}>
                                <div className='col-lg-12'>
                                    <label>Email Id (or) Mobile Number<sup>*</sup></label><br />
                                    <input 
                                        name="user_name"
                                        placeholder='Enter Your Name' 
                                        value={formData.user_name} 
                                        onChange={handleChange} 
                                        required 
                                    />
                                </div>
                                <div className='col-lg-12'>
                                    <label>Password <sup>*</sup></label><br />
                                    <input 
                                        name="password" 
                                        type="password" 
                                        placeholder='Enter Your Password' 
                                        value={formData.password} 
                                        onChange={handleChange} 
                                        required 
                                    />
                                </div>
                                <div className='col-lg-12'>
                                    <button type='submit'>Submit</button>
                                </div>
                                <div className='col-lg-12 already-acc'>
                                    <p>If you don't have an Account?</p>
                                   <Link 
  to="/Register-Page" 
  state={{ product_id, size: addsize, quantity }}
>
  Register
</Link>

                                </div>
                                <div className='col-lg-12 already-acc'>
                                    <h5 
                                        onClick={handleGuestLogin} 
                                        style={{ cursor: 'pointer', color: '#227070'}}
                                    >
                                        Guest Login
                                    </h5>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {showPopup && (
                <Popup 
                    message={popupMessage} 
                    title={popupTitle} 
                    onClose={closePopup} 
                    type={popupTitle === 'Success' || popupTitle === 'Guest Login' ? 'success' : 'error'} 
                />
            )}
        </div>
    );
};

export default LoginPage;
